import * as types from "./requestFormatTypes";
import { KeyValue } from "@/main/models/common";

interface State {
	data: KeyValue[];
	isLoading: boolean;
	error: string | null;
}

const initialState: State = {
	data: [],
	isLoading: false,
	error: null,
};

const requestFormatReducer = (state = initialState, action: any): State => {
	switch (action.type) {
		case types.GET_PAYLOAD_FORMAT:
			return { ...state, isLoading: true, error: null };
		case types.GET_PAYLOAD_FORMAT_SUCCESS:
			return { ...state, isLoading: false, data: action.payload };
		case types.GET_PAYLOAD_FORMAT_FAILURE:
			return { ...state, isLoading: false, error: action.error };
		default:
			return state;
	}
};
export default requestFormatReducer;
